
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

import VignetteLogo from "@/components/VignetteLogo.vue";
import { ViewAnalytics } from "@/mixins";
import { MetadataKeys } from "@/types";

@Component({
  components: {
    VignetteLogo,
  },
})
export default class ThankYou extends mixins(ViewAnalytics) {
  // Override for PageTitle mixin
  pageName = "Thank You";

  mounted(): void {
    this.setAnalyticsMetadata(MetadataKeys.PAYWALLED_CONTENT_STATUS, "Public");
    this.setAnalyticsMetadata(MetadataKeys.PAGE_TYPE, "Public Page");
    this.setAnalyticsMetadata(MetadataKeys.SITESECTION, "Public Pages");
    this.pushPageViewEvent();
  }
}
